"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShortUrl = exports.safeJsonParse = exports.getFullyQualifiedUrl = void 0;
const nanoid_1 = require("nanoid");
const defaultConfig = {
    get: (key, defaultValue = "") => defaultValue,
};
const getFullyQualifiedUrl = (path, defaultBase = typeof window !== "undefined" &&
    typeof (window === null || window === void 0 ? void 0 : window.origin) !== "undefined"
    ? window === null || window === void 0 ? void 0 : window.origin
    : "https://set.live") => {
    let url = new URL(path, defaultBase);
    return url.toString();
};
exports.getFullyQualifiedUrl = getFullyQualifiedUrl;
const safeJsonParse = (text) => {
    try {
        return JSON.parse(text);
    }
    catch (error) {
        return undefined;
    }
};
exports.safeJsonParse = safeJsonParse;
/**
 * Create a short URL and save it to the database.  `writer` should be a
 * function that actually writes the document.  Using the admin SDK, it would
 * look something like:
 *
 *    const writer = (path, data) => admin.firestore().doc(path).set(data);
 *
 * While for the v9 client SDK it would be:
 *
 *    const writer = (path, data) => setDoc(doc(getFirestore(), path), data);
 */
const createShortUrl = (url, writer, config = defaultConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const nanoid = (0, nanoid_1.customAlphabet)("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ23456789");
    const idLength = parseInt(config.get("app.short_url_length", "8")) || 8;
    const alphaId = nanoid(idLength);
    const short_url = config.get("app.short_url", "https://go.set.live");
    if (writer) {
        const path = `${config.get("app.short_url_collection", "urls")}/${alphaId}`;
        yield writer(path, { url });
    }
    const shortUrl = new URL(alphaId, short_url);
    return { url: shortUrl.toString(), code: alphaId };
});
exports.createShortUrl = createShortUrl;
//# sourceMappingURL=index.js.map